import 'css-chunksrc/client/pages/occupancyPage/table/styles.scss';export default {
  "tableWrapper": "_tableWrapper_1wh1c_1",
  "table": "_table_1wh1c_1",
  "monthRow": "_monthRow_1wh1c_12",
  "monthCornerCell": "_monthCornerCell_1wh1c_20",
  "monthCell": "_monthCell_1wh1c_32",
  "headerRow": "_headerRow_1wh1c_48",
  "withMonthRow": "_withMonthRow_1wh1c_56",
  "resourceHeaderCell": "_resourceHeaderCell_1wh1c_60",
  "headerCell": "_headerCell_1wh1c_80"
};